import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AlertController,NavController } from '@ionic/angular';
import { HelperService } from 'src/app/services/helper.service';
import { ActionSheetController } from '@ionic/angular';
import { StoreService } from 'src/app/services/store.service';
import { UserService } from 'src/app/services/user.service';
import { ToastService } from 'src/app/services/toast.service';
@Component({
  selector: 'app-brand',
  templateUrl: './brand.page.html',
  styleUrls: ['./brand.page.scss'],
})
export class BrandPage implements OnInit {
  displayVal="";
  category: any;
  subCategory: any;
  isPromoActiveFlag: any;
  storeDetail: any;
  city = localStorage.getItem('city');
  pin: any;
  searchParams: any;
  isLoadData: boolean;
  searchResultData: any=[];
  resultsAvailable: boolean=false;
  backPageFlag: any={};
  resultsNotAvailable=0;
  noDataImage : any;
  offset : any=0;
  a:boolean=false;
  product: any;
  cart: any = [];
  qty: number = 1;
  show: any;
  
 @Input() item;

 userId = localStorage.getItem("userId");
 loading : boolean=false;
  n: any;
  @ViewChild('input', { static: false }) input: ElementRef;
  searchTerm: string;
constructor(private routerActivate: ActivatedRoute,  private router: Router, private authService: StoreService,   public actionSheetController: ActionSheetController, public alertController: AlertController, private navController:NavController,private toast: HelperService
  ,private userService: UserService){
    this.userService.cartUpdated.subscribe(res => {
      let cart = localStorage.getItem('cart');
      if(cart){
        this.n = JSON.parse(cart).length;
      }
    })
 
  }
/***Added by Parul for searching the products and get suggestion based on typing */

ngOnInit() {
  this.searchResultData=[];
  
  // console.log("enter in ngOnInit function")
  this.routerActivate.queryParams.subscribe(params => {
    if (this.router.getCurrentNavigation().extras.state) {
      this.category = this.router.getCurrentNavigation().extras.state.cat;
      this.subCategory = this.router.getCurrentNavigation().extras.state.subCat;
      this.isPromoActiveFlag = this.router.getCurrentNavigation().extras.state.isPromoActiveFlag;
      this.storeDetail = this.router.getCurrentNavigation().extras.state.backPageFlag.storeDetail;
      this.city = this.router.getCurrentNavigation().extras.state.city;
      this.pin = this.router.getCurrentNavigation().extras.state.pin;
      this.backPageFlag = this.router.getCurrentNavigation().extras.state.backPageFlag;
      this.searchParams = this.router.getCurrentNavigation().extras.state.search;
      this.product =  this.router.getCurrentNavigation().extras.state.product;
    }
  });

  console.log('***',this.product);
  this.searchParams = this.product

}
handleAddToCart(productObj) {
  let promoListobj = {
    productdetails: productObj,
    userId: this.userId
  }
 
  
  }

fetchCatStoreTerm1(searchParams,loaded,event?) {
  if(!loaded){
    this.searchResultData=[];
  }
  
  console.log(this.searchParams,"hello")
  if (this.searchParams.length > 2) {
    if(loaded){
      this.offset+=20;
    }
    const formData = {
      "search": this.searchParams,
      "city": this.city,
      limit : 20,
      offset : this.offset
    }
    this.authService.getProduct(formData).subscribe((result: any) => {
      console.log(result.length);
      this.searchResultData=[...this.searchResultData,...result];
      if(this.searchResultData.length>0){
          this.resultsAvailable=true;
          this.resultsNotAvailable=0;
          console.log("hello")
      }
      else{
        this.resultsNotAvailable=1;
        console.log("hiiii")
        
      }

       if(event){
      event.target.complete();
    }
  })}else{
    this.searchResultData=[];
  }

}
supplierSelected(productItem:any){
  console.log(productItem);
    //let qty = 1;
    // console.log("product item object clickable product", productItem);
    // let navigationParams: NavigationExtras = { state: { productId: productItem._id, promotionId: productItem.promotionId, productQty: qty, city:this.city,backPageFlag: { cat: this.category, subCat: this.subCategory, backPageFlagInfo: this.backPageFlag.backPageFlagInfo, isPromoActiveFlag: this.isPromoActiveFlag,storeDetail: this.storeDetail,city:this.city,pin:this.pin,storeId:this.backPageFlag.storeId,
    //   productId:this.backPageFlag.productId, bannerOfferType:this.backPageFlag.bannerOfferType,articleNumber: this.backPageFlag.articleNumber, imageName:this.backPageFlag.imageName } } };
    //   console.log("product item object clickable product", navigationParams);
    this.router.navigate(['/product-detail/'+productItem._id]);
    // console.log("product item object clickable product", navigationParams);
}

doInfinite($event){
  if (this.searchParams.length > 2) {
    const formData = {
      "search": this.searchParams,
      "cat": this.category,
      "subcat": this.subCategory,
      "city": this.city,
      limit : 30,
      offset : 30
    }
    this.authService.getProduct(formData).subscribe((result: any) => {
      console.log(result);
      this.searchResultData=result;
      if(this.searchResultData.length>0){
          this.resultsAvailable=true;
      }
      
    })}
}
goBack(){
  this.router.navigate(['/'], { skipLocationChange: true });
}

notifications(){
  this.router.navigate(['/wishlist'])
}
home(){
  this.router.navigate(['/'])
}

handleMissingImage($event){
  console.log($event)
  console.log("hello error");
  ($event.target as HTMLImageElement).style.display = 'none'
  this.a=true;
}
// fetchCatStoreTerm(event) {
//   console.log(event)
//   let navigationParams: NavigationExtras = { state: {searchTerm : event, city: this.city, pin: this.pin, backPageFlag: { backPageFlagInfo: "H", city: this.city, pin: this.pin } } };
//   this.router.navigate(['/search-product'], navigationParams);
// }

}
